import React, { useEffect } from 'react';
import { Tooltip as MuiTooltip, IconButton, Chip } from '@mui/material';
import {
	DRAGGABLE_ELEMENT_TYPES,
	lowercaseFirstLetter,
	READABLE_ENTITY_TYPES,
	resolveEntityName,
	UserManagedEntityState,
} from '@elyx-code/project-logic-tree';
import { EditorService } from '../services/editor';
import Tooltip from '../lib/tooltip/Tooltip';

export const EntityDialogHeader: React.FC<{
	entity: UserManagedEntityState;
	project: EditorService;
	onClose: (event: any) => void;
}> = ({ entity, project, onClose }) => {
	const [entityName, setEntityName] = React.useState<string>(
		resolveEntityName(entity, project.logic)
	);

	useEffect(() => {
		project.on(entity.id, () => {
			const newName = resolveEntityName(entity, project.logic);
			if (newName !== entityName) {
				setEntityName(newName);
			}
		});
	}, []);

	const isCanvasEntity = DRAGGABLE_ELEMENT_TYPES.includes(entity.type);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<div
				style={{
					padding: '40px 40px 0 40px',
					display: 'flex',
					alignItems: 'center',
					gap: '16px',
				}}
			>
				<IconButton
					id='entity-header-dialog-back-arrow-button'
					className='dialog_back_button'
					onClick={onClose}
					style={{
						fontSize: 14,
						width: 22,
						height: 22,
						color: 'rgb(63, 63, 64)',
					}}
				>
					<i className='fa-solid fa-arrow-left' />
				</IconButton>
				<Tooltip
					anchorQuerySelector='#entity-header-dialog-back-arrow-button'
					placement='bottom'
					openDelay={300}
				>
					Go back to the previous screen
				</Tooltip>
				<h1 style={{ margin: 0, fontWeight: 500, fontSize: '28px' }}>
					{READABLE_ENTITY_TYPES[entity.type].singular}
					{isCanvasEntity ? ' node builder' : ' builder'}
				</h1>
				{!entity.editable && (
					<MuiTooltip
						title={`This ${lowercaseFirstLetter(
							READABLE_ENTITY_TYPES[entity.type].singular
						)} has been locked to the current version, and can no longer be edited`}
					>
						<Chip
							size='small'
							color='error'
							variant='outlined'
							className='card-tag'
							style={{
								boxShadow: 'none',
							}}
							label={
								<span>
									<i className='fa-regular fa-lock'></i>
									&nbsp;Locked
								</span>
							}
						/>
					</MuiTooltip>
				)}
			</div>

			<p
				style={{
					margin: 0,
					color: 'rgba(127, 85, 85, 0.54)',
					padding: '0px 40px 0 80px',
				}}
			>
				{entityName || `${READABLE_ENTITY_TYPES[entity.type].singular} builder`}
			</p>
		</div>
	);
};

export default EntityDialogHeader;
